import { render, staticRenderFns } from "./CreateSection.vue?vue&type=template&id=3fd859dd&"
import script from "./CreateSection.vue?vue&type=script&lang=js&"
export * from "./CreateSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports